import { Components, Theme } from "@mui/material";

export const MuiFormControl: Components<Theme>["MuiFormControl"] = {
  styleOverrides: {
    root: {
      paddingX: ".5rem",
    },
  },
};
